import * as React from 'react';

type Props = React.HTMLAttributes<SVGSVGElement> & {
  height?: string;
  width?: string;
};

const AILayoutIcon = ({ height, width, ...attributes }: Props) => {
  return (
    <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" height={height} width={width} {...attributes}>
      <path d="M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.996.996 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12z" />
    </svg>
  );
};

export default AILayoutIcon;
